import * as React from "react";
import { renderEventIcons } from "./renderEventIcons";
import { renderMarketsCount } from "./renderMarketsCount";
import { CardPropsHandlers } from "../../../../../typings";
import { BaseDict } from "../../../dict";
import { Event } from "../../../../../contracts";

export const renderIconsWrapper = (event: Event, componentPrefix: string, dict: BaseDict, handlers: CardPropsHandlers, isDesktop: boolean) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__icons-holder`} data-uat={`div-ev-list-${componentPrefix}-icons-holder`}>
        {renderEventIcons(event, dict, isDesktop, handlers)}
        {!isDesktop && renderMarketsCount(componentPrefix, event.marketLinesCount)}
    </div>